import _each from "lodash/each";
import _concat from "lodash/concat";
import News from "~/js/brands/news";
export default class ShopDetail {

    constructor() {

        /**
         * Global
         */
        this.shopDetailData = undefined
        this.$shopDetailContent = $('#shop-detail-content')
        
        /**
         * Map style
         */
        const STYLE_OPTION = [
        {
            "stylers": [
            {
                "visibility": "off"
            }
            ]
        },
        {
            "elementType": "geometry",
            "stylers": [
            {
                "visibility": "on"
            }
            ]
        },
        {
            "elementType": "labels",
            "stylers": [
            {
                "visibility": "off"
            }
            ]
        },
        {
            "featureType": "administrative.land_parcel",
            "stylers": [
            {
                "visibility": "simplified"
            }
            ]
        },
        {
            "featureType": "administrative.land_parcel",
            "elementType": "labels.text",
            "stylers": [
            {
                "visibility": "on"
            }
            ]
        },
        {
            "featureType": "administrative.neighborhood",
            "stylers": [
            {
                "visibility": "off"
            }
            ]
        },
        {
            "featureType": "administrative.province",
            "elementType": "labels",
            "stylers": [
            {
                "visibility": "on"
            }
            ]
        },
        {
            "featureType": "poi",
            "elementType": "labels.text",
            "stylers": [
            {
                "visibility": "off"
            }
            ]
        },
        {
            "featureType": "poi.attraction",
            "elementType": "labels",
            "stylers": [
            {
                "visibility": "on"
            }
            ]
        },
        {
            "featureType": "poi.park",
            "elementType": "labels",
            "stylers": [
            {
                "visibility": "on"
            }
            ]
        },
        {
            "featureType": "road",
            "elementType": "labels",
            "stylers": [
            {
                "visibility": "on"
            }
            ]
        },
        {
            "featureType": "road",
            "elementType": "all",
            "stylers": [
            {
                "saturation": -100
            },
            {
                "lightness": 45
            },
            {
                "visibility": "on"
            }
            ]
        },
        {
            "featureType": "road",
            "elementType": "labels.icon",
            "stylers": [
            {
                "gamma": "1.00"
            },
            {
                "visibility": "on"
            },
            {
                "saturation": "100"
            },
            {
                "hue": "#0053ff"
            }
            ]
        },
        {
            "featureType": "transit.station",
            "elementType": "labels",
            "stylers": [
            {
                "visibility": "on"
            }
            ]
        },
        {
            "featureType": "transit.station.bus",
            "elementType": "labels",
            "stylers": [
            {
                "visibility": "on"
            }
            ]
        },
        {
            "featureType": "transit.station.rail",
            "elementType": "labels",
            "stylers": [
            {
                "visibility": "on"
            }
            ]
        },
        {
            "featureType": "transit.station.rail",
            "elementType": "labels.text",
            "stylers": [
            {
                "visibility": "on"
            },
            {
                "weight": 0.5
            }
            ]
        },
        {
            "featureType": "landscape",
            "elementType": "all",
            "stylers": [
            {
                "color": "#eeeeee"
            }
            ]
        },
        {
            "featureType": "landscape",
            "elementType": "geometry.fill",
            "stylers": [
            {
                "visibility": "on"
            },
            {
                "color": "#eeeeee"
            }
            ]
        },
        {
            "featureType": "water",
            "elementType": "all",
            "stylers": [
            {
                "color": "#b4d4e1"
            },
            {
                "visibility": "on"
            }
            ]
        },
        {
            "featureType": "water",
            "elementType": "geometry.fill",
            "stylers": [
            {
                "visibility": "on"
            },
            {
                "color": "#c4e3ec"
            }
            ]
        },
        {
            "featureType": "road.highway",
            "elementType": "geometry.fill",
            "stylers": [
            {
                "color": "#e9e9e9"
            },
            {
                "visibility": "on"
            }
            ]
        },
        {
            "featureType": "road.highway",
            "elementType": "geometry.stroke",
            "stylers": [
            {
                "color": "#cfcece"
            }
            ]
        },
        {
            "featureType": "administrative.country",
            "stylers": [
            {
                "visibility": "off"
            }
            ]
        },
        {
            "featureType": "administrative.locality",
            "stylers": [
            {
                "visibility": "on"
            }
            ]
        }
        ]
        
        /**
         * Check shop exists
         */
        if (shopMasterObjectData) {
            let params = this.getParams()
            this.shopDetailData = shopMasterObjectData.find(shop => shop.shop_code == params['shop_code'])
        }
        
        this.render()
        window.initMap = this.initMap
    }

    render(params) {
        /**
         * Render Content
         */
        if (typeof this.shopDetailData !== "undefined") {
            const template = _.template($('[data-js="shop-detail__template"]').html())
            this.$shopDetailContent.html(template({
            data: this.shopDetailData
            }))
            $('.p-carousel__list').slick({infinite: true, arrows: false})
            document.title = this.shopDetailData.name+" - "+document.title
            //pankuzu
            const breadcrumb = document.querySelector(".breadcrumb__inner")
            breadcrumb.insertAdjacentHTML('beforeend', `<a href="/pages/storesdetail?shop_code=${this.shopDetailData.shop_code}" class="current" aria-current="page">
            <span>${this.shopDetailData.name}</span>
            </a>`)
            
            //旗艦店以外はニュースはなし
            const section = document.getElementById("storenews");
            if(this.shopDetailData.is_flagship == false){
                section.remove()
                return false;
            }
            //ニュースの取得
            let query = [];
            for (i = 1; i <= 14; i++){
                if(this.shopDetailData['brand'+i] != ""){
                    if(this.shopDetailData['brand'+i] == "ISSEY MIYAKE"){
                        query.push('tag:"'+handleize("ISSEY MIYAKE Brand")+'"');
                    }else if(this.shopDetailData['brand'+i] == "HOMME PLISSÉ ISSEY MIYAKE"){
                        query.push('tag:"HOMME PLISSÉ ISSEY MIYAKE"');
                    }else{
                        query.push('tag:"'+handleize(this.shopDetailData['brand'+i])+'"');
                    }
                }
            }
            //Gallery
            if(this.shopDetailData['gallery'] != ""){
                query.push('tag:"'+handleize(this.shopDetailData['gallery'])+'"');
            }
            //店舗
            if(this.shopDetailData['shop_code'] != ""){
                query.push('tag:"shop_code_'+handleize(this.shopDetailData['shop_code'])+'"');
            }
            query = query.join(' OR ');
            
            const url = "/search?q=tag:search_news AND "+query+"&view=article-ajax-json&type=article";
        
            fetch(url)
            .then(response => response.json())
            .then((responseJson) => {
            if(Object.keys(responseJson).length <= 0){
                section.remove();
                return;
            }
            let html = "";
            let count = 0
            for (const element of responseJson) {
                count++;
                if(count > 8) {
                    element.html = element.html.replace('_cell', '_cell js-news__invisible');
                }
                html += element.html
            }
            if(html != ""){
                section.querySelector('._cellContainer').innerHTML = html;
                section.querySelector('._cellContainer').classList.add("loaded")
            }else{
                section.remove();
            }
            this.news = new News(".js-news");
            
            })
            .catch((error) => {
                console.error('Error:', error);
            });
            
        } else {
            const template = _.template($('[data-js="shop-detail-not-found__template"]').html())
            this.$shopDetailContent.html(template)
            setTimeout(function() {
               location.href = 'https://httpscloning-isseymiyake-com.myshopify.com/pages/stores';
              }, 500);
        }
    }

    /**
     * InitMap for Google
     */
    initMap() {
        let defaultOptions = {
        styles: STYLE_OPTION,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        scrollwheel: false,
        disableDoubleClickZoom: true,
        mapTypeControl: false,
        center: new google.maps.LatLng(
                parseFloat(this.shopDetailData.latitude),
                parseFloat(this.shopDetailData.longitude)
            ),
            zoom: 16
        }
    
        // set Marker
        new google.maps.Marker({
        position: new google.maps.LatLng(parseFloat(this.shopDetailData.latitude), parseFloat(this.shopDetailData.longitude)),
        map: new google.maps.Map(document.getElementById("map"), defaultOptions),
        icon: {
            url: this.getAssetByName('img_cluster_ss.png'),
            size: new google.maps.Size(24, 30),
        }
        })
    }
    
    /**
     * @returns {*}
     */
    getParams() {
        let result = []
        let url = document.location.href
        let qs = url.substring(url.indexOf('?') + 1).split('&')
    
        for (let i = 0; i < qs.length; i++) {
        qs[i] = qs[i].split('=')
        result[qs[i][0]] = decodeURIComponent(qs[i][1])
        }
    
        return result
    }
    
    /**
     * @param fileName
     */
    getAssetByName(fileName) {
        if (shopListAsset) {
        return shopListAsset.replace('FILE', fileName)
        }
    }
}